module.exports = __webpack_public_path__ + "static/media/config-download.49fdc849.png";